module.exports = function() {
  return new Worker("/" + "less-transpiler.dabeced6.worker.js");
};